import styled, { keyframes } from "styled-components";

const spinAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const LoaderStyled = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 2px solid #fff;
    border-left-color: black;
    animation: ${spinAnimation} 1s linear infinite;
`;